import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import FilesUpload from "./molecules/FilesUpload";
import PageWrapper from "components/PageWrapper";
import TissueSelect from "./molecules/TissueSelect";

function UploadSlide() {
    // Загрузка состояния из localStorage
    const savedTissue = localStorage.getItem("tissue");

    const [tissue, setTissue] = useState(savedTissue || "");

    const typeObj = "qupath"; // Значение для type_obj
    const versionModel = "1"; // Значение для version_model

    // Сохранение состояния в localStorage при изменении
    useEffect(() => {
        localStorage.setItem("tissue", tissue);
    }, [tissue]);

    const StyleCap = {
        textAlign: "center",
        marginTop: "17px",
        fontWeight: "bold"
    };

    return (
        <PageWrapper>
            <div className="Cap" style={StyleCap}>
                Добавить слайд в обработку
            </div>
            <Box sx={{ width: "70%", margin: "70px 200px auto" }}>
                <TissueSelect tissue={tissue} setTissue={setTissue} />
                <FilesUpload
                    tissue={tissue}
                    typeObj={typeObj}
                    versionModel={versionModel}
                />
            </Box>
        </PageWrapper>
    );
}

export default UploadSlide;
